import { useContext } from 'react';
import NavigationGuardContext from '@/context/NavigationGuardContext';

const useNavigationGuard = () => {
  const ctx = useContext(NavigationGuardContext);
  if (!ctx) throw new Error('useNavigationGuard must be used within NavigationGuardProvider');
  return ctx;
};

export default useNavigationGuard;
